export const comorbidityotherspText = {
  values: [
    { value: 'other', text: 'Annet', score: 0 },
    { value: 'othet', text: 'Free text', score: 0 },
  ],
};
